import zone from "./zone";
import start from "./start";
import tripDuration from "./tripDuration.js";
import Age from "./age.js";
import coverageType from "./coverageType";
import vehiclemodel from "./vehiclemodel";
import vehicleyear from "./vehicleyear";
import vehicleprice from "./vehicleprice";
import confirmprice from "./confirmprice";
import additionalinfo from "./additionalinfo";
import depreciationmessage from "./depreciationmessage";
import gapinsurance from "./gapinsurance";
import promotions from "./promotions";
import savequotation from "./savequotation";
import promotionsstep2 from "./promotionsstep2";
import paymentoptions from "./paymentoptions";
import customvehiclemake from "./customvehiclemake";
import vehicalregistration from "./vehicalregistration";
import additionalcover from "./additionalcover";
import sendtosurveyor from "./sendtosurveyor";
import allowcamera from "./allowcamera";
import preparinginsurancepolicy from "./preparinginsurancepolicy";
import vehicalchassis from "./vehicalchassis";
import providecnic from "./providecnic";
import comprehensiveinfo from "./comprehensiveinfo";
import isexcellent from "./isexcellent";
import isgood from "./isgood";
import isbad from "./isbad";
import unstaisfiedinfo from "./unstaisfiedinfo";
import payment from "./payment";
import insurancepayment from "./insurancepayment";
import vehicalcolor from "./vehicalcolor";
import getmysavequote from "./getmysavequote";
import getmysavedpolicy from "./getmysavedpolicy";
import policypaper from "./policypaper";
import vehicalregistrationConfirm from "./vehicalregistrationConfirm";
import vehicalcolorConfirm from "./vehicalcolorConfirm";
import providecnicConfirm from "./providecnicConfirm";
import PolicyEmail from "./policyemail";
import getmypendingpolicy from "./getmypendingpolicy";
const getDataTravelInsurance = async (type, msg) => {
  let newMessage;
  console.log("type ::", type);
  if (type === "start") {
    newMessage = new start(msg);
  } else if (type === "zone") {
    newMessage = new zone(msg);
  } else if (type === "duration") {
    newMessage = new tripDuration(msg);
  } else if (type === "age") {
    newMessage = new Age(msg);
  } else if (type === "coverageType") {
    newMessage = new coverageType(msg);
  } else if (type === "payment") {
    newMessage = new confirmprice(msg);
  } else if (type === "isexcellent") {
    newMessage = new isexcellent(msg);
  } else if (type === "isgood") {
    newMessage = new isgood(msg);
  } else if (type === "isbad") {
    newMessage = new isbad(msg);
  } else if (type === "unstaisfiedinfo") {
    newMessage = new unstaisfiedinfo(msg);
  } else if (type === "confirmpayment") {
    newMessage = new payment(msg);
    console.log("confirmation ::::> ", newMessage);
  }
  // else if (type === "vehicalcolor") {
  //   newMessage = new vehicalcolor(msg);
  // }
  // else if (type === "getmysavequote") {
  //   newMessage = new getmysavequote(msg);
  // }
  // else if (type === "getmysavedpolicy") {
  //   newMessage = new getmysavedpolicy(msg);
  // }
  // else if (type === "getmypendingpolicy") {
  //   newMessage = new getmypendingpolicy(msg);
  // }
  //  else if (type === "policypaper") {
  //   newMessage = new policypaper(msg);
  // }
  //  else if (type === "insurancepayment") {
  //   newMessage = new insurancepayment(msg);
  // }
  //  else if (type === "vehicalregistrationConfirm") {
  //   newMessage = new vehicalregistrationConfirm(msg);
  // }
  //  else if (type === "vehicalcolorConfirm") {
  //   newMessage = new vehicalcolorConfirm(msg);
  // }
  //  else if (type === "providecnicConfirm") {
  //   newMessage = new providecnicConfirm(msg);
  // }
  //  else if (type === "policy") {
  //   newMessage = new PolicyEmail(msg);
  // }

  return {
    modal: await newMessage.getAllItems(),
  };
};

export default getDataTravelInsurance;
